module.exports = __WEBPACK_EXTERNAL_MODULE_87__;


//////////////////
// WEBPACK FOOTER
// external "chokidar"
// module id = 87
// module chunks = 0